import { Pipe, PipeTransform } from '@angular/core';
import { MessageGroup } from '../models/message-group';
import { TEMP_PARTICIPANT_ID } from '../util/constants';

@Pipe({

  name: 'isSentFromYou',
})
export class SentFromYouPipe implements PipeTransform {
  transform(group: MessageGroup, currentParticipantId: string | null): boolean {
    return group.participantId === TEMP_PARTICIPANT_ID || group.participantId === currentParticipantId;
  }
}
